export const COD_THANK_YOU_COMPONENT_CONFIG = {
  knownCustomer: {
    backgroundColor: '#FFFFFF',
  },
  unknownCustomer: {
    backgroundColor: '#FFFFFF',
  },
  active: true,
};
